import { Expose, Type } from 'class-transformer';

import { SnModel } from '@lib/common/models';

import { SnUser } from '../user/user';

export class FsSavedSearch extends SnModel {
  @Expose()
  public id: string;

  @Expose()
  @Type(() => SnUser)
  public user: SnUser;

  @Expose()
  public name: string;

  @Expose()
  public organization: IOrganization;

  @Expose()
  public endpoint: string;

  @Expose()
  public type: string;

  @Expose()
  public description: string;

  @Expose()
  public queryParams: any;

  @Expose()
  public isActiveAlert: boolean;

  @Expose()
  public isPrivate: boolean;

  @Expose()
  public rule: any;

  @Expose()
  public createdTimestamp: Date;

  @Expose()
  public updatedTimestamp: Date;

  @Expose()
  public isRuleActive: boolean;

  @Expose()
  public notificationCreateAlarm: boolean;

  @Expose()
  public lockTime: number;

  constructor(data: any = {}) {
    super();
    this.fromJSON(data);
  }
}

export interface IOrganization {
  id: string;
  name: string;
}
